// AUTO-GENERATED CODE, DO NOT EDIT!
/* eslint-disable */

import * as Types from '../../../../generated-types'

import gql from 'graphql-tag'
export type ResponseToolbarFragment = {
  __typename?: 'Interest'
  id: number
  matchedAt?: any | null
  guestInitiated: boolean
  host: { __typename?: 'User'; id: number; avatar?: string | null }
  message?: {
    __typename?: 'Message'
    id: number
    email: string
    phone?: string | null
    declinedAt?: any | null
    declinedReasons: Array<{
      __typename?: 'DeclineReason'
      id: string
      text: string
    }>
  } | null
}

export type ResponseToolbarHostFragment = {
  __typename?: 'User'
  id: number
  avatar?: string | null
}

export const ResponseToolbarHostFragmentDoc = gql`
  fragment ResponseToolbarHost on User {
    id
    avatar
  }
`
export const ResponseToolbarFragmentDoc = gql`
  fragment ResponseToolbar on Interest {
    id
    matchedAt
    guestInitiated
    host {
      ...ResponseToolbarHost
    }
    message {
      id
      email
      phone
      declinedAt
      declinedReasons {
        id
        text
      }
    }
  }
  ${ResponseToolbarHostFragmentDoc}
`
